import { cn } from '@/lib/utils';
import { memo } from 'react';

interface Props {
  message?: string;
  inline?: boolean;
  className?: string;
}

const ThinkingIndicator = memo(({ message, inline, className }: Props) => {
  const text = message || 'Thinking…';

  if (inline) {
    return (
      <div
        className={cn(
          'flex items-center gap-3 text-sm text-muted-foreground',
          className
        )}
        aria-live="polite"
        role="status"
      >
        <span className="inline-flex h-3.5 w-3.5 items-center justify-center">
          <span className="h-3.5 w-3.5 rounded-full bg-foreground/80 animate-pulse" />
        </span>
        <span className="font-medium tracking-wide">{text}</span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex items-center gap-3 px-4 py-3 text-sm text-muted-foreground',
        className
      )}
      aria-live="polite"
      role="status"
    >
      <span className="inline-flex h-3.5 w-3.5 items-center justify-center">
        <span className="h-3.5 w-3.5 rounded-full bg-foreground/80 animate-pulse" />
      </span>
      <span className="font-medium tracking-wide">{text}</span>
    </div>
  );
});

ThinkingIndicator.displayName = 'ThinkingIndicator';

export { ThinkingIndicator };
